<template>
  <v-row no-gutters class="pt-5">
    <v-col class="pr-2">
      <card-title-row
        translation-path="sidebar.modelingNetworkCheckTitle"
        class="mb-5"
        :has-buttons="false"
      ></card-title-row>
      <sidebar-row icon="mdi-tooltip-check" icon-color="rgba(0,0,0,0.7)">
        <template>
          <v-row no-gutters>
            <v-col cols="auto">
              <base-button translation-path="sidebar.check" class="px-6" @click="getErrorObjects"></base-button>
            </v-col>
          </v-row>
        </template>
      </sidebar-row>
      <main-loader v-if="isFetching"></main-loader>
      <modeling-network-errors
        :errors="computedErrors"
        :error-count="errorCount"
        v-if="errorCount > 0 && isFetched"
        @fixProblem="handleErrorFix($event)"
      ></modeling-network-errors>
      <div v-else-if="errorCount === 0 && isFetched">{{ $i18n.t('sidebar.noErrors') }}</div>
    </v-col>
  </v-row>
</template>

<script>
import CardTitleRow from '@/components/CardTitleRow';
import SidebarRow from '@/components/SidebarRow';
import BaseButton from '@/components/BaseButton';
import ModelingNetworkErrors from '@/components/ModelingNetworkErrors';
import { call, get } from 'vuex-pathify';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'ModelingNetworkCheck',
  components: { MainLoader, ModelingNetworkErrors, BaseButton, SidebarRow, CardTitleRow },
  data: () => ({
    isFetching: false,
    isFetched: false,
  }),
  computed: {
    errors: get('epanet/errors'),
    computedErrors() {
      return this.errors.map(value => {
        return {
          errorType: value.errorType,
          ...value.errors,
          count: value.errors.errors.length,
          tooltipText: this.getTooltipText(value.errors.fixable),
          multipleChoice: this.hasMultipleChoice(value.errorType),
          tableHeaders: this.getTableHeaders(value.errorType),
        };
      });
    },
    errorCount() {
      return this.computedErrors.map(error => error.errors).reduce((a, b) => a + b.length, 0);
    },
  },
  methods: {
    getErrors: call('epanet/getErrors'),
    fixError: call('epanet/fixError'),
    updateErrors: call('epanet/updateErrors'),

    getTableHeaders(type) {
      if (type === 'null_attributes') {
        return [
          { text: this.$i18n.t('sidebar.dataSource'), value: 'datasource_name', width: '20%' },
          { text: this.$i18n.t('sidebar.objectId'), value: 'id', width: '20%' },
          { text: this.$i18n.t('sidebar.columnName'), value: 'columnName', width: '30%' },
          { text: '', value: 'actions', sortable: false, width: '30%', align: 'end' },
        ];
      } else if (type === 'duplicate_points') {
        return [
          { text: this.$i18n.t('sidebar.dataSource'), value: 'datasource_name' },
          { text: this.$i18n.t('sidebar.objectId'), value: 'id' },
          { text: this.$i18n.t('sidebar.pointsIds'), value: 'pointIds' },
          { text: '', value: 'actions', sortable: false, width: '30%', align: 'end' },
        ];
      } else {
        return [
          { text: this.$i18n.t('sidebar.dataSource'), value: 'datasource_name' },
          { text: this.$i18n.t('sidebar.objectId'), value: 'id' },
          { text: '', value: 'actions', sortable: false, width: '30%', align: 'end' },
        ];
      }
    },
    hasMultipleChoice(type) {
      return type === 'no_parent_pipe' || type === 'bad_parent_pipe' || type === 'null_attributes';
    },
    getTooltipText(value) {
      return value ? this.$i18n.t('sidebar.modelingCheck.fix') : this.$i18n.t('sidebar.modelingCheck.cantFix');
    },
    async handleErrorFix(data) {
      const { index, errorType, selected, dataSource, id } = data;
      const payload = {
        errorType: errorType,
        index: index,
        dataSource: dataSource,
        feature: id,
      };
      if (errorType === 'no_parent_pipe' || errorType === 'bad_parent_pipe') {
        payload.parent_pipe_id = selected;
        payload.feature = id;
      } else {
        payload.feature = id;
      }
      const r = await this.fixError(payload);
      if (r.status === 200) {
        await this.updateErrors({ errorType, index });
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.problemFixed'),
        });
      } else {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.fixProblemFailed'),
        });
      }
    },
    async getErrorObjects() {
      this.isFetched = false;
      this.isFetching = true;
      await this.getErrors();
      this.isFetching = false;
      this.isFetched = true;
    },
  },
};
</script>

<style scoped></style>
